import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ConfigurationSettingComponent } from './configuration-setting/configuration-setting.component';
import { DataTableListComponent } from './data-table-list/data-table-list.component';
import { ConfigurationListComponent } from './configuration-list/configuration-list.component';
import { DeviceListComponent } from './device-list/device-list.component';
import { ChartWithOverviewComponent } from './chart-with-overview/chart-with-overview.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'configurationSetting', component: ConfigurationSettingComponent },
  { path: 'dataTable', component: DataTableListComponent },
  { path: 'configurationList', component: ConfigurationListComponent },
  { path: 'deviceList', component: DeviceListComponent },
  // { path: 'charts', component: ChartWithOverviewComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
